export const documentLibraryVersion = '11.1.0';
